import "@manapp/ui/styles.css"

import { I18nProvider, Toaster, TooltipProvider } from "@manapp/ui"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { configureApi, setApiController } from "./api"
import { AuthProvider } from "./auth/auth-context"
import { oidcBackend } from "./auth/oidc-backend"
import { AuthController, broadcastChannel } from "./auth/session"
import { AuthGate } from "./app/auth-gate"
import { OrgGate } from "./app/org-gate"
import { AppRouter } from "./app/routes"
import { isEstimatorEnabled, loadConfig, setEstimatorEnabled } from "./config"
import { appI18n } from "./i18n"

async function bootstrap() {
  const root = document.getElementById("root")
  if (!root) throw new Error("Missing #root element")
  const config = await loadConfig()
  setEstimatorEnabled(isEstimatorEnabled(config))
  const controller = new AuthController(oidcBackend(config), broadcastChannel(), window.sessionStorage)
  setApiController(controller)
  configureApi()
  const i18n = appI18n()
  const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000 } } })
  createRoot(root).render(
    <StrictMode>
      <I18nProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider controller={controller}>
            <TooltipProvider>
              <AuthGate>
                <OrgGate>
                  <AppRouter />
                </OrgGate>
              </AuthGate>
            </TooltipProvider>
            <Toaster />
          </AuthProvider>
        </QueryClientProvider>
      </I18nProvider>
    </StrictMode>,
  )
  await controller.start(window.location.href)
}

void bootstrap()
